import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { AutomationTarget } from '@rossum/api-client/queues';
import { Alert, Stack } from '@rossum/ui/material';
import { boldText } from '../../../../../lib/formaterValues';
import { getLatestSavedAutomationTarget } from '../utils';

export const StoredOptimizationAlert = ({
  savedAutomationTargets,
}: {
  savedAutomationTargets: AutomationTarget[] | undefined;
}) => {
  const intl = useIntl();

  const lastDate = useMemo(() => {
    if (!savedAutomationTargets || savedAutomationTargets.length === 0)
      return null;
    const result = getLatestSavedAutomationTarget(savedAutomationTargets);

    if (result?.type === 'legacy_thresholds') return null;

    return result?.datetime ?? null;
  }, [savedAutomationTargets]);

  return lastDate ? (
    <Stack>
      <Alert severity="info">
        {intl.formatMessage(
          {
            id: 'containers.settings.queues.queue.automation.optimization.storedAutomationAlert.title',
          },
          {
            date: intl.formatDate(new Date(lastDate), {
              dateStyle: 'medium',
            }),
            boldText,
          }
        )}
      </Alert>
    </Stack>
  ) : null;
};
